/**
 * @generated SignedSource<<355da3ad81d8a9f0a4e33958135c7d0b>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type destinationsListQuery$variables = {
  owner?: string | null;
};
export type destinationsListQuery$data = {
  readonly destinations: ReadonlyArray<{
    readonly displayName: string | null;
    readonly name: string;
    readonly provider: string;
  }>;
};
export type destinationsListQuery = {
  response: destinationsListQuery$data;
  variables: destinationsListQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "owner"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "owner",
        "variableName": "owner"
      }
    ],
    "concreteType": "Destination",
    "kind": "LinkedField",
    "name": "destinations",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "name",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "provider",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "displayName",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "destinationsListQuery",
    "selections": (v1/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "destinationsListQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "55015a738ec31c49973d2fd3f4e1b6b1",
    "id": null,
    "metadata": {},
    "name": "destinationsListQuery",
    "operationKind": "query",
    "text": "query destinationsListQuery(\n  $owner: String\n) {\n  destinations(owner: $owner) {\n    name\n    provider\n    displayName\n  }\n}\n"
  }
};
})();

(node as any).hash = "73cc8d6b184f12ab4abc12969b5fdf71";

export default node;
